import { Component } from '@angular/core';
import { TutorialLayoutComponent } from '../core/tutorial.layout.component';
import { UtilService } from '../../../util/UtilService';

@Component({
    selector: 'app-tutoriallayoutdesktop',
    templateUrl: './tutorial.layout.desktop.component.html',
    styleUrls: ['../css/tutorial.layout.desktop.component.scss'],
    standalone: false
})
export class TutorialLayoutDesktopComponent extends TutorialLayoutComponent {
  constructor(public _utilService: UtilService) {
    super(_utilService);
  }
}
